// const SERVER_BASE_URL = 'http://localhost:4000';
const SERVER_BASE_URL = 'https://storexplore.herokuapp.com';
const CURRENCY = '₦';
const ONE = 1;

export { CURRENCY, ONE, SERVER_BASE_URL };
